// app/routes/articles.tsx
import { Link, json, useLoaderData } from "@remix-run/react"
import type { LoaderFunction } from "@remix-run/node"
import fs from "fs"
import path from "path"
import {
  articleBlurb,
  articleDetails,
  articleSection,
  articleTitle,
  h1Style,
  h1Wrap,
  headerTextStyle,
  imagePreviewBlog,
  shrinkingGrid,
  shrinkingGridItem,
} from "./article.css"
import Logo from "~/components/Logo"
import { page } from "~/shared/styles.css"
import Footer from "~/components/Footer"
import StickyHeader from "~/components/StickyHeader"

// export let loader: LoaderFunction = async () => {
//   // Path to your articles directory

//   const articlesDir = path.join(process.cwd(), "app/routes")

//   //   // Read the files in the directory
//   const files = fs.readdirSync(articlesDir)

//   const articles = files.filter(
//     (file) =>
//       file.startsWith("article.") && !file.includes("_index") && !file.includes(".css.")
//   )

//   const descriptions = articles.map((article) => {
//     const articlePath = path.join(process.cwd(), `app/routes/${article}`)
//     const file = fs.readFileSync(articlePath, "utf-8")
//     const firstIndex = file.indexOf("export const meta: MetaFunction = () => {")
//     const lastIndex = file.indexOf("]\n}", firstIndex) + 3
//     const meta = file.slice(firstIndex, lastIndex)

//     const descriptionObjIndex = meta.indexOf('name: "description"')
//     const lastDescriptionObjIndex = meta.indexOf("},", descriptionObjIndex)
//     const descriptionObj = meta.slice(descriptionObjIndex, lastDescriptionObjIndex)
//     const textIndex = descriptionObj.indexOf("content:") + "content:".length
//     const lastTextIndex = descriptionObj.indexOf('",', textIndex)

//     const descriptionText = descriptionObj.slice(textIndex, lastTextIndex).trim().slice(1)

//     const imageObjIndex = meta.indexOf('property: "og:image"')
//     const lastImageObjIndex = meta.indexOf("},", imageObjIndex)
//     const imageObj = meta.slice(imageObjIndex, lastImageObjIndex)
//     const imageIndex = imageObj.indexOf("content:") + "content:".length
//     const lastImageIndex = imageObj.indexOf(",", imageIndex)

//     let imageUrl = imageObj.slice(imageIndex, lastImageIndex).trim()
//     imageUrl = imageUrl.slice(1, imageUrl.length - 1)

//     return { descriptionText, imageUrl }
//   })

//   const pages = articles.map((file, i) => {
//     const slug = file.replace(".tsx", "").replace("article.", "")
//     return {
//       slug,
//       description: descriptions[i].descriptionText,
//       url: descriptions[i].imageUrl,
//     }
//   })

//   return json({ pages })
// }

export const meta: MetaFunction = () => {
  return [
    {
      title: "AI Garden Design Articles & Blog",
    },
    {
      name: "description",
      content:
        "Discover gardening tips and instructions as well as the incorporation of AI in your gardening routine",
    },
    {
      property: "og:title",
      content: "AI Garden Design Articles & Blog",
    },
    {
      property: "og:description",
      content:
        "Discover gardening tips and instructions as well as the incorporation of AI in your gardening routine",
    },
    {
      property: "og:image",
      content:
        "https://rescapeai.com/rosegardens/e80f1046-70d1-4277-bf36-84e8c75091cf.webp",
    },
    {
      tagName: "link",
      rel: "canonical",
      href: "https://rescapeai.com/articles",
    },
    // {
    //   "script:ld+json": {
    //     "@context": "https://schema.org",
    //     "@type": "Article",
    //     headline: "AI Yard Design | Revolutionising Outdoor Spaces with Rescape",
    //     description:
    //       "Explore the future of landscaping with landscape design for backyard. Transform your outdoor space creating tailored, stunning AI yard design effortlessly.",
    //     author: {
    //       "@type": "Organization",
    //       name: "Rescape AI",
    //     },
    //     datePublished: "2024-06-28",
    //     dateModified: "2024-06-28",
    //     publisher: {
    //       "@type": "Organization",
    //       name: "Rescape AI",
    //       logo: {
    //         "@type": "ImageObject",
    //         url: "https://rescapeai.com/logo.webp",
    //       },
    //     },
    //     image: "https://rescapeai.com/articles/ai-yard-design-patio-and-flowerbeds.webp",
    //     mainEntityOfPage: {
    //       "@type": "WebPage",
    //       "@id": "https://rescapeai.com/article/ai-yard-design",
    //     },
    //     articleSection: ["Gardening", "Artificial Intelligence", "Technology"],
    //   },
    // },
  ]
}

const ArticlesList = () => {
  // const { pages } = useLoaderData<{
  //   pages: { slug: string; description: string; url: string }[]
  // }>()

  // console.log(pages)

  const pages = [
    {
      slug: "free-trial-ai-garden-design",
      root: false,
      description: "Test out Rescape AI and transform a photo of your outdoor space.",
      url: "/articles/free-trial.webp",
    },
    {
      slug: "ai-garden-design-tool",
      root: true,
      description:
        "Rescape AI is an AI garden design tool that transforms a photo of your outdoor space into professional design ideas in seconds.",
      url: "/articles/small-garden-0ed3562e.webp",
    },
    {
      slug: "small-garden-ideas",
      root: true,
      description: "Small Garden Ideas That Make Every Inch Count.",
      url: "/articles/248d8f94-104f-48c0-88bd-4b36cea2c8213-cropped.webp",
    },
    {
      slug: "ai-garden-design",
      root: true,
      description:
        "Updated November 17th. Discover the transformative power of AI garden design | Upload your photo, customise the style and features and instantly get tailored design suggestions.",
      url: "https://rescapeai.com/ai-garden-design/wildlife-garden-with-pond-ai-generated.webp",
    },
    {
      slug: "choosing-plants-suitable-for-different-us-hardiness-zones",
      description:
        "Discover the top trees, shrubs, and perennials for your US hardiness zone. Find plants that thrive in your climate with expert tips and advice.",
      url: "/articles/achillea_millefolium.webp",
    },
    {
      slug: "gardening-while-adapting-to-climate-change",
      description:
        "Discover how resilient planting, smart design and biodiversity can help gardens thrive in a changing climate.",
      url: "/articles/bee-collecting-pollen.webp",
    },
    {
      slug: "ai-backyard-design",
      root: true,
      description:
        "Transforms backyard and garden design. Experience personalized backyard makeovers effortlessly. Perfect for homeowners, DIY enthusiasts and landscape architects.",
      url: "https://rescapeai.com/articles/ai-yard-design-patio-and-flowerbeds.webp",
    },
    {
      slug: "ai-landscape-design",
      root: true,
      description:
        "Discover how AI landscape design can transform your garden. Visualize, customize, and create your dream outdoor space with ease using Rescape AI.",
      url: "https://rescapeai.com/articles/ai-yard-design-patio-and-flowerbeds.webp",
    },
    {
      slug: "ai-yard-design",
      root: true,
      description:
        "Explore the future of landscaping with landscape design for backyard. Transform your outdoor space creating tailored, stunning AI yard design effortlessly.",
      url: "https://rescapeai.com/rosegardens/e80f1046-70d1-4277-bf36-84e8c75091cf.webp",
    },
    {
      slug: "back-garden-ideas",
      description:
        "Discover new ideas, techniques and styles for your back garden with AI. Upload a photo of your garden and realise it's potential with endless choice.",
      url: "https://rescapeai.com/styles/urban.webp",
    },
    {
      slug: "contemporary-garden-ideas-with-rescape-ai",
      description:
        "Contemporary garden ideas with an AI garden design tool. Create a contemporary escape using Rescape AI. It's easy and quick to visualise styles in your space.",
      url: "https://rescapeai.com/how-to-design-a-contemporary-garden/third-ai-garden-design-with-stone-paving-area.webp",
    },
    {
      slug: "garden-design-app",
      root: true,
      description:
        "Planning a new garden or remodeling? Rescape AI's garden design app offers a professional-level tool to help you make the most of your outdoor space.",
      url: "https://rescapeai.com/transform-your-garden-with-rescape-ai/english-garden-cottage-garden-elements-high-creativity.webp",
    },
    {
      slug: "how-to-use-ai-for-landscape-design",
      description:
        "Discover how Rescape AI excels at landscape design and can help generate professional-level backyard ideas.",
      url: "https://rescapeai.com/articles/ai-yard-design-patio-and-flowerbeds.webp",
    },
    {
      slug: "nature-in-contemporary-design",
      description:
        "Design breathtaking gardens with Rescape AI's garden design app. Blend nature and modern elements for stunning contemporary outdoor spaces.",
      url: "https://rescapeai.com/styles/contemporary.webp",
    },
    {
      slug: "transform-your-garden-with-rescape-ai",
      description:
        "Discover the future of garden design with Rescape's AI landscape design tool. Create innovative, nature-inspired outdoor spaces effortlessly.",
      url: "https://rescapeai.com/transform-your-garden-with-rescape-ai/wildlife-friendly-natural-pond.webp",
    },
  ]

  return (
    <>
      <div
        className={h1Style}
        style={{
          textAlign: "center",
          backgroundImage: "url(/ai-garden-design/cozy-balcony-ai-generated.webp)",
        }}
      >
        <div className={h1Wrap}>
          <Logo width="108px" />
          <h1 className={headerTextStyle}>
            AI Landscape and Garden Design Insights from Rescape AI
          </h1>
        </div>
      </div>
      <StickyHeader status="SignUp" />
      <div className={page}>
        <section className={articleSection}>
          <ul className={shrinkingGrid}>
            {pages.map((article) => (
              <li key={article.slug} className={shrinkingGridItem}>
                <Link
                  to={!article.root ? `/article/${article.slug}` : `/${article.slug}`}
                  style={{ position: "absolute", top: 0, right: 0, bottom: 0, left: 0 }}
                >
                  <img src={article.url} className={imagePreviewBlog} />
                  <span className={articleDetails}>
                    <h2
                      className={articleTitle}
                      style={{
                        textTransform: "capitalize",
                      }}
                    >
                      {article.slug.replaceAll("-", " ")}
                    </h2>
                    <p className={articleBlurb}>{article.description}</p>
                  </span>
                </Link>
              </li>
            ))}
          </ul>
        </section>
        <Footer />
      </div>
    </>
  )
}

export default ArticlesList
